import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PriceEstimativaListComponent } from './price-estimativa-list.component';
import { PriceEstimativaComponent } from './price-estimativa.component';
import { PriceEstimativaResumoComponent } from './price-estimativa-resumo.component';
import { AuthGuard } from '../helpers/auth.guard';
import { PriceSimulacaoComponent } from './price-simulacao-list.component';

const routes: Routes = [
  { path: 'projeto/estimativa-list/:projetoId', component: PriceEstimativaListComponent, canActivate: [AuthGuard] },
  { path: 'projeto/estimativa-resumo/:id', component: PriceEstimativaResumoComponent, canActivate: [AuthGuard] },
  { path: 'projeto/estimativa-edit/:id', component: PriceEstimativaComponent, canActivate: [AuthGuard] },
  { path: 'usuario/estimativa/:statusId', component: PriceEstimativaListComponent, canActivate: [AuthGuard] },
  { path: 'usuario/simulacoes/:statusId', component: PriceSimulacaoComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PriceRoutes { }
